/* Green Group - Contigo theme JS */
(function () {
  'use strict';

  // Mobile menu toggle
  var toggle = document.getElementById('mobileToggle');
  var menu = document.getElementById('navMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      menu.classList.toggle('open');
    });
  }

  // Quantity steppers (product page)
  document.addEventListener('click', function (e) {
    var input = document.getElementById('qtyInput');
    if (!input) return;
    if (e.target.matches('[data-qty-plus]')) {
      input.value = parseInt(input.value || '1', 10) + 1;
    }
    if (e.target.matches('[data-qty-minus]')) {
      var v = parseInt(input.value || '1', 10) - 1;
      input.value = v < 1 ? 1 : v;
    }
  });

  // AJAX add to cart for product cards (keeps user on page)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product-form');
    if (!form) return;
    // Only intercept the small product-card forms (grid), let main product page submit normally
    if (!form.closest('.product-card')) return;

    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Agregando...'; btn.disabled = true; }

    var data = new FormData(form);
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = document.getElementById('cartCount');
        if (count) count.textContent = cart.item_count;
        if (btn) { btn.textContent = '\u2713 Agregado'; }
        setTimeout(function () {
          if (btn) { btn.textContent = original; btn.disabled = false; }
        }, 1500);
      })
      .catch(function () {
        if (btn) { btn.textContent = original; btn.disabled = false; }
        form.submit();
      });
  });
})();
